<template>
    <div class="main">

        <div class="bank-title">
            <Header></Header>
        </div>
        <div class="content">
            <div class="box">
                <div class="left same">
                    <div class="left-top">
                        <div class="server">
                            <div>
                                <span class="card_">活畜交易</span>

                            </div>
                            <!-- <div class="date">
                                <span @click="animalBtn('1')" :class="{ active: status === '1' }">牛</span>
                                <span @click="animalBtn('2')" :class="{ active: status === '2' }">羊</span>
                            </div> -->
                        </div>
                        <div class="add">
                            <div class="add_item">
                                <span class="num">2.65</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>交易金额(亿)</span>
                                </div>
                            </div>
                            <div class="add_item">
                                <span class="num">23568</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>交易数量(头)</span>
                                </div>
                            </div>
                        </div>
                        <div class="block">
                            <span></span>
                            <span>活畜交易趋势</span>
                        </div>
                        <div id="lineChart"></div>
                    </div>
                    <div class="left-bottom">
                        <div class="block">
                            <span></span>
                            <span>活畜交易品类分布</span>
                        </div>
                        <div id="pieChart"></div>
                    </div>
                </div>
                <div class="center">
                    <div class="center-top">
                        <span class="hand">累计综合交易金额(亿)</span>
                        <ul>
                            <li v-for="(item, i) in numberList" :key="i" :class="{ round: item == '.' }">{{ item }}</li>
                        </ul>
                    </div>
                    <!-- 
                        <div class="mapBox" id="mapBox">
                        </div> -->
                    <div class="mapBox" id="mapBox"></div>

                    <div class="server">
                        <div>
                            <span class="card_">产品溯源</span>

                        </div>
                        <div class="text-search">
                            <span class="source-info" @click="goSource">溯源信息</span>
                        </div>
                        <!-- <div class="text-search">
                            <el-input v-model="input" @keyup.enter="sreach" placeholder="请输入溯源码"></el-input>
                            <el-button type="primary" class="btn" @click="sreach">搜索</el-button>
                        </div> -->
                    </div>
                    <div class="scroll-box1">
                        <div class="center-top" style="margin-top: .2rem;justify-content: space-around;">
                            <div style="display: flex;align-items: baseline;">
                                <span class="hand">溯源码(万个)</span>
                                <ul>
                                    <li v-for="(item, i) in sourceData" :key="i" :class="{ round: item == '.' }">{{ item }}
                                    </li>
                                </ul>
                            </div>
                            <div style="display: flex;align-items: baseline;">
                                <span class="hand">扫描量(万次)</span>
                                <ul>
                                    <li v-for="(item, i) in sourceData1" :key="i" :class="{ round: item == '.' }">{{ item }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="scroll-box">

                        <div class="scroll-left-box">
                            <div class="scroll-txt" v-for="(item, i) in tableData" :key="i">
                                <div class="city">
                                    <span>{{ item.no }}</span>
                                    <span>{{ item.city }}</span>
                                </div>
                                <div class="number">{{ item.num }}</div>
                                <div class="number">{{ item.number }}</div>
                            </div>
                        </div>
                        <div class="scroll-right-box">
                            <div class="scroll-txt" v-for="(item, i) in tableData1" :key="i">
                                <div class="city">
                                    <span>{{ item.no }}</span>
                                    <span>{{ item.city }}</span>
                                </div>
                                <div class="number">{{ item.num }}</div>
                                <div class="number">{{ item.number }}</div>
                            </div>
                        </div>
                        <!-- <dv-scroll-ranking-board :config="config" style="width:100%;height:2.5rem;" /> -->
                    </div>
                </div>
                <div class="right same">
                    <div class="right-top">
                        <div class="server">
                            <div>
                                <span class="card_">商城交易</span>
                            </div>
                        </div>
                        <div class="add">
                            <div class="add_item">
                                <span class="num">1.20</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>交易金额(亿)</span>
                                </div>
                            </div>
                            <div class="add_item">
                                <span class="num">452202</span>
                                <div style="margin-top: 0.11rem;">
                                    <span>交易订单(单)</span>
                                </div>
                            </div>
                        </div>
                        <div class="block">
                            <span></span>
                            <span>商城交易趋势</span>
                        </div>
                        <div id="lineChart1"></div>

                    </div>
                    <div class="right-bottom">
                        <div class="block">
                            <span></span>
                            <span>商品交易品类分布</span>
                        </div>
                        <div id="barChart"></div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div class="bottom">
                    <span @click="activeBtn('1')" :class="{ 'active1': active1 == '1' }">产业流通</span>
                    <span @click="activeBtn('2')" :class="{ 'active1': active1 == '2' }">
                        产业电商
                    </span>
                    <span @click="activeBtn('3')" :class="{ 'active1': active1 == '3' }">产业行情</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import Header from "./components/head.vue";
import mapJson from './map'
import heatmapData from './heatmap'
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
    components: {

        Header
    },
    data() {
        return {
            heatmapData: heatmapData,
            status: '1',
            lineData: [
                { name: '', value: [23.45, 24.92, 25.58, 25.16, 24.99, 24.72, 25.23], month: ['08-10', '08-11', '08-12', '08-13', '08-14', '08-15', '08-16'] },
            ],
            lineData1: [
                { name: '', value: [10.27, 11.30, 9.34, 12.18, 10.03, 9.32, 10.12], month: ['08-10', '08-11', '08-12', '08-13', '08-14', '08-15', '08-16'] },
            ],
            barData: [
                { title: "", value: [11340.36, 8044.29, 5106.36, 5014.59, 3902.34, 2712.27, 2406.03], label: ['饲草', '饲料', '预混料', '玉米', '辅料', '农机', '兽药'] }
            ],
            pieData: [
                { value: 6156, name: '育肥牛' },
                { value: 5983, name: '公牛犊' },
                { value: 4055, name: '母牛犊' },
                { value: 3996, name: '基础母牛' },
                { value: 3378, name: '淘汰母牛' },
            ],
            numberList: ['3', '.', '8', '5'],
            input: '',
            active1: '2',
            config: {
                data: [
                    {
                        name: '内蒙古',
                        value: 50231
                    },
                    {
                        name: '北京',
                        value: 42331
                    },
                    {
                        name: '河南',
                        value: 32123
                    },
                    {
                        name: '广州',
                        value: 30847
                    },
                    {
                        name: '吉林',
                        value: 22238
                    },
                    {
                        name: '上海',
                        value: 20394
                    },
                ],
                unit: '次',
                rowNum: 4
            },

            // config1: {
            //     data: [
            //         {
            //             name: '广州',
            //             value: 30847
            //         },
            //         {
            //             name: '吉林',
            //             value: 22238
            //         },
            //         {
            //             name: '上海',
            //             value: 20394
            //         },
            //     ],
            //     unit: '次',
            //     rowNum: 3
            // }

            tableData: [
                {
                    no: 'NO.1',
                    city: '广州',
                    num: '1104379 个',
                    number: '211230 次'
                },
                {
                    no: 'NO.3',
                    city: '深圳',
                    num: '1001793 个',
                    number: '133107 次'
                },
                {
                    no: 'NO.5',
                    city: '杭州',
                    num: '208794 个',
                    number: '98794 次'
                },
            ],
            tableData1: [
                {
                    no: 'NO.2',
                    city: '上海',
                    num: '1050374 个',
                    number: '197426 次'
                },
                {
                    no: 'NO.4',
                    city: '北京',
                    num: '509725 个',
                    number: '101230 次'
                },
                {
                    no: 'NO.6',
                    city: '福建',
                    num: '109971 个',
                    number: '98602 次'
                },
            ],
            map: null,
            centers: {
                lng: 104.114129,
                lat: 38.450339
            },
            heatmap: {},
            sourceData: ['4', '5', '5', '.', '3', '0'],
            sourceData1: ['1', '3', '5', '.', '0', '8'],
        };
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.initScatter)
    },
    created() {

        var _this = this;
        document.addEventListener("keydown", _this.watchEnter);
        // 获取近七日
        // this.getDays()
    },
    destroyed() {
        //移除监听回车按键
        var _this = this;
        document.removeEventListener("keydown", _this.watchEnter);
        console.log(3434);
    },
    mounted() {
        this.setLineData(this.lineData, 'lineChart')
        this.setLineData(this.lineData1, 'lineChart1')
        this.setBarData(this.barData)
        this.setPieChart(this.pieData)
        this.draw(mapJson)

    },
    methods: {
        activeBtn(val) {
            this.active1 = val
            if (val == '1') {
                location.href = 'https://rpt.gtc315.cn/tongliao/index?c=ltyx'
            }
            if (val == '2') {
                return
            }
            if (val == '3') {
                location.href = 'https://rpt.gtc315.cn/tongliao/index?c=cysc'
            }
        },
        animalBtn(val) {
            this.status = val
        },
        sreach() {
            if (!this.input) {
                this.$message.error('请输入溯源码！');
                return
            }
            // if (this.input.length != 18) {
            //     this.$message.error('请输入18位有效数字溯源码！');
            //     return
            // }
            this.$router.push({ path: '/source' })
        },
        //监听回车按钮事件
        watchEnter(e) {
            var keyNum = window.event ? e.keyCode : e.which; //获取被按下的键值
            //判断如果用户按下了回车键（keycody=13）
            if (keyNum == 13) {
                this.sreach()
            }
        },
        goSource() {
            console.log(12);
            this.$router.push({ path: '/source' })
        },
        // 近七日
        getDays() {
            this.$http({
                url: 'screenapp-service/aErShan/seven/days',
                //请求方式
                method: 'get',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.lineData[0].month = data.result
                    this.lineData1[0].month = data.result
                } else {
                    // this.$message.error(data);
                }
                this.setLineData(this.lineData, 'lineChart')
                this.setLineData(this.lineData1, 'lineChart1')
            })
        },
        // 自定义饼图图例
        getFormatter(data, name) {
            let arr = []
            let count, amount
            let sum = 0
            data.forEach((item) => {
                sum += item.value
                return sum
            })
            for (const item of data) {
                if (item.name == name) {
                    count = `${(item.value / sum * 100).toFixed(2)}%`,
                        amount = item.value
                }
            }
            if (sum == 0) {
                count = `0%`
            }
            arr = [name, count, amount + '头']
            return arr.join('  ')
        },
        // 设置折线图
        setLineData(data, dom) {
            const colors = ['#1EE7E7', '#0EDAE2', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#FFFFFF' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.month
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "8%",
                    right: "3%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            var linechart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        // console.log(params, 'params');
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].value + '(万元)'
                            }</p>
                         `;
                        // return params.name
                    },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '20%',
                    left: '5%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '金额(万元)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 0, 0, 0],
                        lineHeight: 45,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 4,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            linechart.clear();
            linechart.setOption(option)
            window.addEventListener('resize', () => {
                linechart.resize()
            })
        },
        // 柱状图
        setBarData(data) {
            var barchart = this.$echarts.init(document.getElementById('barChart'))
            // 隐藏动画加载效果。
            var option = {
                title: {
                    text: '',
                    textAlign: 'left',
                    textStyle: {
                        color: '#00DAC8', // 主标题文字的颜色。
                        fontSize: 18, // 字体大小
                        lineHeight: '30', // 行高
                    },
                    triggerEvent: false, // 是否触发事件
                    x: 'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    formatter: function (params) {
                        // console.log(params,'params');
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].value + '(万元)'
                            }</p>
                         `;
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: '',
                grid: {
                    top: '25%',
                    // 20
                    left: '7%',
                    right: '4%',
                    bottom: '3%',
                    // height: '150px',
                    // 130
                    // 150
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: data[0].label,
                },
                yAxis: {
                    name: '金额(万元)',
                    // name:this.cattleStatus=="cattle"?'数量(头)':'数量',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 50, 0, 0],
                        lineHeight: 60,
                    },
                    type: 'value',
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: '#6FB6FF',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: {
                    // name: barData.name,
                    type: 'bar',
                    barWidth: '15',
                    barGap: 0,
                    emphasis: {
                        focus: "series",
                    },
                    backgroundStyle: {
                        // color: 'rgba(44, 118, 254, 0.2)'
                        color: '#00FFFF'
                    },
                    itemStyle: {
                        // opacity: 0.8,
                        // color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //         offset: 1,
                        //         color: "#297DFC",
                        //     },
                        //     {
                        //         offset: 0,
                        //         color: "#06FDF5",
                        //     },
                        // ]),
                        color: "#00FFFF"
                    },
                    data: data[0].value,
                },
            }
            barchart.clear();
            barchart.setOption(option)
            window.addEventListener('resize', () => {
                barchart.resize()
            })
        },
        setPieChart(data) {
            var myChart = this.$echarts.init(document.getElementById('pieChart'));
            var option = {
                color: ['#2c76fe', '#0EDAE2', '#ec7d30', '#E7C660'],
                grid: {
                    top: '0%',
                    left: '10%',
                    bottom: '0%'
                    // height: '60px',
                    // height: "100%",
                },
                legend: {
                    icon: "circle",
                    bottom: "0%",
                    left: "center",
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 20,
                    padding: [10, 90, 0, 0],
                    textStyle: { color: '#00E0DB' },
                    formatter: (name) => {
                        return this.getFormatter(data, name)
                    },
                },
                tooltip: {
                    trigger: 'item',
                    padding: 5,
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 2)
                        return `
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">${params.data.name + `(头)`}： ${params.data.value || 0} </span>
                        </p><br/> 
                         `;
                    },
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['30%', '50%'],
                        center: ['50%', '40%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#FFFFFF',
                            // formatter: ' {b} {d}% \n\n',
                            formatter: function (params) {
                                if (params.percent === undefined) {
                                    return params.name + 0 + '%\n\n'
                                } else if (params.percent === 0) {
                                    return params.name + params.percent + '%\n\n'
                                } else {
                                    return params.name + params.percent + '%\n\n'
                                }
                            },
                            padding: [0, -80],
                            alignTo: 'labelLine'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                // fontSize: '40',
                                // fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true,
                            length: 15,
                            length2: 60,
                            lineStyle: {
                                color: '#73c0de',
                            }
                        },
                        data: data
                    }
                ]
            };
            myChart.clear()
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        // 地图
        draw(geoJson) {

            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            // geoJson.features.forEach((item) => {     
            //     item['properties']['cp'] = item.properties.center
            // })
            // this.$echarts.registerMap("bayannaoer", geoJson);
            let data = this.heatmapData
            let areaData = [];
            data.map((item) => {
                // 扩大热力图效果
                // areaData.push(...new Array(4).fill(item));
                areaData.push(...new Array(1).fill(item));
            });
            let mapMax = Math.max(...data.map((item) => item[2]));
            let mapMin = Math.min(...data.map((item) => item[2]));

            this.chart.hideLoading();
            // 隐藏动画加载效果。

            var option = {
                tooltip: {
                    label: {
                        show: false,
                    },
                    textStyle: {
                        color: '#fff'
                    },
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00d4cf;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                    },
                },
                visualMap: {
                    type: 'continuous',
                    show: false,
                    calculable: false,
                    right: 30,
                    bottom: 20,
                    itemWidth: 13,//图形的宽度，即长条的宽度。
                    itemHeight: 80,
                    // showLabel: !0,
                    text: [`${mapMax}`, '0'],
                    // realtime: false,
                    // calculable: true,
                    color: ['#fa0023', '#84d100', '#90ff07', '#edcc00', '#004684'],
                    min: mapMin,
                    max: mapMax,
                    // continuous: {
                    //     type: 'piecewise',
                    // itemGap: 12,
                    align: 'left',
                    // itemSymbol: 'circle',
                    // itemWidth: 8,
                    // itemHeight: 8,
                    textStyle: { color: '#fff' },
                },
                grid: {
                    height: '100%',
                    width: '100%',
                },

                geo: [
                    {
                        map: 'china',
                        top: '29%',
                        left: '20%',
                        roam: true,
                        // width: '90%',
                        // height: '95%',
                        zoom: 1.7,
                        // z: 1,
                        label: {
                            normal: {
                                show: false,
                                color: 'transparent',
                                fontSize: 22,
                            }
                        },
                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter: function (params) {
                                //   // console.log(params)
                                //   return params.name
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#13182a"
                            }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#131729',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#32737b", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                // areaColor: 'rgba(33,80,231,1)',
                                areaColor: "#131729",
                                // borderColor: "#4ECEE6",
                                borderColor: "#32737b",
                                borderWidth: 1,
                                // shadowColor: "#2C99F6",
                                // shadowOffsetY: 0,
                                // shadowBlur: 25,
                            },
                        },
                    },
                ],

                series: [
                    {
                        mapType: 'GD',
                        name: 'AQI',
                        type: 'heatmap',
                        coordinateSystem: 'geo',
                        data: areaData,
                        blurSize: 10,
                        pointSize: 10, // 设置热力图上点的大小
                        symbolSize: 200,
                        itemStyle: {
                            normal: {
                                width: 2,
                                color: 'skyblue'
                            }
                        },


                    },

                ],
            }
            this.chart.clear()
            // setTimeout(() => {

            // }, 100)

            this.chart.setOption(option)

            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        // 地图
        drawssss(geoJson, data) {

            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            // geoJson.features.forEach((item) => {     
            //     item['properties']['cp'] = item.properties.center
            // })
            // this.$echarts.registerMap("bayannaoer", geoJson);
            this.chart.hideLoading();
            // 隐藏动画加载效果。
            var option = {
                legend: false,
                tooltip: {
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {

                        //     return `
                        //     <p style="color:#00E0DB;font-size: 20px;">${params.data.name}</p><br/>
                        //     <p>
                        //    <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.data.code == "养殖户分布" ? '养殖户数量' : '活畜数量'}<span style="color: #00E0DB; font-size: 16px;">${params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">${params.data.code == "养殖户分布" ? "家" : '头'}</span> </span>
                        //           </p>
                        //           `;
                    },
                },
                grid: {
                    // top: '25%',
                    // show: true,
                    // height:'700px'
                },
                geo3D: {

                    type: "map3D", // 系列类型
                    name: "map3D", // 系列名称
                    zoom: 1,
                    // aspectScale: 1.2, //长宽比
                    map: "china", // 地图 类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                    data: data ? data : [],
                    top: '5%',
                    left: '0%',
                    // bottom:'50%',
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 12, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                        // align: 'center',
                        // verticalAlign: 'middle'
                        // normal: {
                        //     show: true,
                        //     color: 'rgba(5, 176, 220, 1)',
                        //     fontSize: 1, //此处字体需做兼容适配

                        //     align: 'left',
                        //     verticalAlign: 'middle',
                        //     position: 'inside',
                        //     distance: 15,
                        // },
                        // emphasis: {
                        //     show: true,
                        //     color: '#ececec'
                        // }
                    },
                    itemStyle: {
                        // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                        // color: "rgba(33,80,231,1)", // 地图板块的颜色
                        color: '#07212c',
                        opacity: 1, // 图形的不透明度 [ default: 1 ]
                        borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                        borderColor: "#00ffff", // 图形描边的颜色。[ default: #333 ]
                    },
                    regionHeight: 5,//地图图层厚度
                    emphasis: {
                        // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                        label: {
                            // label高亮时的配置
                            show: false,
                            textStyle: {
                                color: "#fff", // 高亮时标签颜色变为 白色
                                fontSize: 15, // 高亮时标签字体 变大
                            },
                            // formatter : function(params) {
                            //     console.log(params)
                            // }
                        },
                        itemStyle: {
                            "color": "#00E0DB"
                        }
                    },
                    groundPlane: {
                        // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
                        show: false, // 是否显示地面。[ default: false ]
                        color: "#aaa", // 地面颜色。[ default: '#aaa' ]
                    },
                    light: {
                        // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
                        main: {
                            // 场景主光源的设置，在 globe 组件中就是太阳光。
                            color: "#fff", //主光源的颜色。[ default: #fff ]
                            intensity: 1.2, //主光源的强度。[ default: 1 ]
                            shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                            shadowQuality: "medium", // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                            alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                            beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
                        },
                    },

                    viewControl: {
                        // 用于鼠标的旋转，缩放等视角控制。
                        projection: "perspective", // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
                        autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
                        autoRotateDirection: "cw", // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
                        autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                        autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
                        damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
                        rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
                        zoomSensitivity: 0, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
                        panSensitivity: 0, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
                        panMouseButton: "left", // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                        rotateMouseButton: "left", // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                        orthographicSize: 60,
                        // distance: 200, 
                        distance: 90, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
                        minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
                        maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。
                        alpha: 60, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
                        beta: 10, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]  60
                        // minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
                        // maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
                        // minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
                        // maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
                        // center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
                        animation: true, // 是否开启动画。[ default: true ]
                        animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
                        animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果。[ default: cubicInOut ]
                    },

                },
                series: [
                    // {
                    //     // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                    //     type: 'scatter3D',
                    //     coordinateSystem: 'geo3D',
                    //     // symbol:
                    //     //     'path://M16.05197563056946,26.8149C13.072275630569457,26.8576,10.101135630569459,26.4854,7.223625630569458,25.7088C3.458190630569458,24.5826,2.675675630569458,22.9872,2.675675630569458,21.8476C2.675675630569458,20.708,3.464878630569458,19.1058,7.210245630569458,17.9863C9.655305630569458,17.3057,12.177075630569458,16.9407,14.714375630569458,16.9004L14.781275630569459,16.3105C14.781275630569459,15.915,14.781275630569459,15.5396,14.841475630569459,15.1575C14.841475630569459,13.1464,13.503775630569457,11.5711,12.667795630569458,11.5711L12.580845630569458,11.5711C11.813295630569458,11.9313,10.980155630569458,12.1298,10.132975630569458,12.1543C9.730145630569458,12.1565,9.329125630569457,12.1,8.942485630569458,11.9867C7.930195630569458,11.7024,7.110225630569458,10.9575,6.728705630569458,9.97564C6.307345630569458,8.83605,4.641995630569458,8.31987,4.448035630569458,8.26625C3.890975630569458,8.14102,3.474606630569458,7.67523,3.411373630569458,7.10654C3.424827630569458,6.52191,3.827865630569458,6.01902,4.394535630569458,5.8798C5.649655630569458,5.46518,6.959155630569458,5.23927,8.280355630569458,5.20944C9.452155630569457,5.16981,10.611315630569457,5.46259,11.624435630569458,6.05409C13.001375630569457,6.93093,13.847775630569458,8.44142,13.878375630569458,10.0762C14.467175630569457,10.4504,14.978175630569458,10.9353,15.383175630569458,11.504C15.403675630569458,11.5237,15.429075630569457,11.5376,15.456775630569458,11.5443C15.498275630569458,11.5421,15.534875630569458,11.5159,15.550375630569459,11.4772C15.732875630569458,10.888,15.956375630569458,10.3123,16.21917563056946,9.75443C16.535775630569457,9.06628,16.942975630569457,8.42373,17.42977563056946,7.84393C17.43277563056946,7.81944,17.43277563056946,7.79467,17.42977563056946,7.77019C17.42767563056946,7.74274,17.412775630569456,7.71789,17.389675630569457,7.70315C17.235775630569456,7.60297,17.08837563056946,7.49327,16.94817563056946,7.37468C16.592975630569455,7.09066,16.39017563056946,6.65689,16.399775630569458,6.20156C16.399775630569458,6.05409,16.399775630569458,2.50122,19.18877563056946,0.83875C20.124175630569457,0.272958,21.19967563056946,-0.0174341,22.292075630569457,0.000811119C24.064375630569458,0.000811119,26.177875630569456,0.630942,28.57897563056946,1.87109C29.10077563056946,2.13893,29.41757563056946,2.68831,29.38877563056946,3.27519C29.35987563056946,3.86207,28.99067563056946,4.37758,28.44517563056946,4.59272C26.753875630569457,5.30059,25.210975630569457,6.32172,23.897175630569457,7.6026C23.24517563056946,8.31356,22.35967563056946,8.76565,21.40257563056946,8.87627L20.91427563056946,8.87627C20.33097563056946,8.86994,19.75267563056946,8.76804,19.202175630569457,8.57461C18.552375630569458,9.05222,18.05887563056946,9.71251,17.784275630569457,10.4717C16.88997563056946,12.4454,16.464175630569457,14.6,16.540275630569457,16.7663C19.35067563056946,16.8353,22.14327563056946,17.2358,24.860275630569458,17.9595C28.612375630569456,19.079,29.39487563056946,20.6812,29.39487563056946,21.8208C29.39487563056946,22.9604,28.612375630569456,24.5558,24.860275630569458,25.682C21.99057563056946,26.4659,19.026275630569458,26.8472,16.05197563056946,26.8149ZM9.450785630569458,19.1729C8.855535630569458,19.2935,8.313795630569459,19.4343,7.832245630569458,19.5751C5.772295630569458,20.1918,4.595175630569458,21.023,4.595175630569458,21.8476C4.595175630569458,22.6721,5.772295630569458,23.5033,7.825565630569458,24.1335C10.507935630569458,24.8487,13.276875630569458,25.1849,16.05197563056946,25.1323C18.81367563056946,25.1797,21.56867563056946,24.8436,24.238275630569458,24.1335C26.291575630569458,23.5234,27.468675630569457,22.6922,27.468675630569457,21.8677C27.468675630569457,21.0431,26.291575630569458,20.2119,24.238275630569458,19.5952C23.76347563056946,19.4544,23.21497563056946,19.3203,22.619775630569457,19.193Q22.51947563056946,19.193,22.512775630569458,19.2466C22.487075630569457,19.2802,22.487075630569457,19.3269,22.512775630569458,19.3606C22.96777563056946,19.6956,23.24987563056946,20.2167,23.28187563056946,20.7817C23.28187563056946,22.8866,19.523175630569458,23.8385,16.031975630569455,23.8385C12.540715630569458,23.8385,8.78196563056946,22.8799,8.78196563056946,20.7817C8.803415630569457,20.2149,9.078585630569458,19.6879,9.531045630569459,19.3472C9.541295630569458,19.3099,9.541295630569458,19.2705,9.531045630569459,19.2332C9.515185630569459,19.1997,9.48110563056946,19.1786,9.444095630569457,19.1796L9.450785630569458,19.1729ZM18.633675630569456,7.92437C19.890975630569457,3.68775,24.14467563056946,1.77724,29.22097563056946,3.15817C29.30797563056946,3.1838,29.398875630569457,3.13218,29.421675630569457,3.04421C29.447475630569457,2.95535,29.39657563056946,2.86232,29.30797563056946,2.8364C24.07777563056946,1.40185,19.630175630569457,3.4062,18.319275630569457,7.82381C18.288775630569457,7.91103,18.337675630569457,8.00602,18.426275630569457,8.03162L18.473075630569458,8.03162C18.54387563056946,8.03353,18.608175630569455,7.99057,18.633675630569456,7.92437ZM13.283075630569458,11.1957C13.368275630569459,11.1589,13.407275630569458,11.0596,13.370075630569458,10.9745C12.373515630569457,8.64164,8.60807563056946,5.84628,3.371245630569458,6.95236C3.280494630569458,6.97236,3.223419630569458,7.06268,3.244170630569458,7.15346C3.264180630569458,7.24125,3.3498336305694583,7.2975,3.438127630569458,7.28083C8.494375630569458,6.22838,12.132735630569458,8.88967,13.069075630569458,11.1219C13.094775630569458,11.181,13.151975630569458,11.2201,13.216175630569458,11.2225L13.283075630569458,11.1957Z',
                    //     symbol: 'image://' + require('@/assets/tl/heatmap.png'),
                    //     symbolSize: 20,
                    //     // itemStyle: {
                    //     //     normal: {
                    //     //         color: 'red',
                    //     //     },
                    //     // },
                    //     data: [
                    //         {
                    //             name: '纳林陶亥镇',
                    //             value: [110.01666302149337, 39.6283242456816,]
                    //         },
                    //         {
                    //             name: '纳林陶亥镇',
                    //             value: [110.01666302149337, 39.6883242456816]
                    //         },
                    //         {
                    //             name: '纳林陶亥镇',
                    //             value: [110.11666302149337, 39.4883242456816]
                    //         },
                    //         {
                    //             name: '纳林陶亥镇',
                    //             value: [110.11566302149337, 39.6883242456816]
                    //         },
                    //         {
                    //             name: '纳林陶亥镇',
                    //             value: [110.21666302149337, 39.4883242456816]
                    //         },
                    //     ]
                    // },
                ],
            };
            this.chart.clear()
            // setTimeout(() => {

            // }, 100)

            this.chart.setOption(option)

            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.main {

    background: url(~@/assets/tl/bg.png);

    .content {
        width: 100%;
        // display: flex;

        // padding: 0 .25rem;
        .box {
            width: 100%;
            display: flex;
        }

        // height: 100vh;
        .left {
            background: url(~@/assets/tl/border1.png);
            padding: .7rem .25rem .5rem .8rem;

            .left-top {
                width: 100%;
                // height: 6.44rem;
                // background-color: pink;
                // margin-top: .45rem;
                // margin-left: .45rem;

                #lineChart {
                    margin-top: .25rem;
                    width: 100%;
                    height: 3.8rem;
                }
            }

            .left-bottom {
                // margin-top: .25rem;
                width: 100%;

                // height: 4.5rem;
                #pieChart {
                    // margin-top: .25rem;
                    width: 100%;
                    height: 3.9rem;
                }
            }
        }

        .same {
            width: 7.5rem;
            height: 12.7rem;
            background-size: 100% 100%;
            margin-top: -0.3rem;
        }

        .center {
            flex: 1;
            // margin-left: .25rem;

            .center-top {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                // height: 11.5rem;
                margin-top: .63rem;
            }

            .mapBox {
                width: 100%;
                height: 6.8rem;
            }

            .text-search {
                display: flex;
                align-items: center;

                .source-info {
                    // width: 0.63rem;
                    // height: 0.23rem;
                    background: linear-gradient(180deg, rgba(13, 142, 149, 0) 0%, rgba(13, 142, 149, 0.55) 100%);
                    border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                    opacity: 1;
                    border: 0.01rem solid #0D8E95;
                    font-size: 0.13rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #00FFFF;
                    padding: .05rem .08rem;
                    cursor: pointer;
                }

                .el-input {
                    width: 2.76rem;
                    // height: 0.31rem;
                    background: rgba(0, 223, 218, 0.0588);
                    opacity: 1;
                    color: #FFFFFF;


                    ::v-deep .el-input__inner {
                        color: #FFFFFF;
                        width: 2.76rem;
                        height: .31rem !important;
                        background: rgba(0, 223, 218, 0.0588);
                        border: 0.01rem solid rgba(0, 223, 218, 0.4);


                    }
                }

                .btn {
                    width: 0.63rem;
                    height: 0.31rem;
                    line-height: 0rem;
                    display: flex;
                    justify-content: center;
                }

                ::v-deep .el-button--primary {
                    background-color: #00E0DB !important;
                    // border-color: #00E0DB !important;
                    border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                    font-size: 0.2rem;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #032929;
                }
            }

            .scroll-box1 {
                // width: 100%;
                // display: flex;
                // margin-top: .36rem;
                // margin-top: .2rem;

                .hand {
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                }

                ul {}

                li {
                    width: 0.44rem;
                    height: 0.49rem;
                    background: rgba(0, 255, 255, 0.1);
                    box-shadow: inset 0rem 0rem 0.13rem 0rem rgba(0, 255, 255, 0.4);
                    border-radius: 0rem 0rem 0rem 0rem;
                    opacity: 1;
                    border: 0.01rem solid rgba(0, 255, 255, 0.2);
                    font-size: 0.4rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: 700;
                    color: #00FFFF;
                    line-height: 0.45rem;
                    text-align: center;
                    margin-right: .13rem;
                }

                .round {
                    width: 0.15rem !important;
                    height: 0.5rem !important;
                    background: none !important;
                    box-shadow: none !important;
                    border: none !important;
                    // margin: 0 .1rem !important;
                    margin-top: .1rem;
                }
            }

            .scroll-box {
                width: 100%;
                display: flex;
                overflow: hidden;
                height: 1.8rem;
                // margin-top: .36rem;
                // margin-top: .2rem;
            }

            .scroll-left-box {
                flex: 1;
                max-height: 1.8rem;
                // animation: scroll 4s linear infinite;
            }

            .scroll-right-box {
                flex: 1;
                margin-left: .38rem;
                max-height: 1.8rem;
                // animation: scroll 4s linear infinite;
            }

            .scroll-txt {
                display: flex;
                // justify-content: space-around;
                align-items: center;
                margin-top: .15rem;
                width: 4.38rem;
                height: 0.44rem;
                background: rgba(9, 53, 77, 0.36);
                border-radius: 0rem 0rem 0rem 0rem;
                opacity: 1;
                border: 0.01rem solid #1A7E91;
                font-size: 0.18rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;

                .city {
                    display: flex;
                }

                span:nth-child(1) {
                    margin-left: .15rem;
                }

                span:nth-child(2) {
                    margin-left: .24rem;
                    display: inline-block;
                    width: .5rem;
                }

                .number {
                    flex: 1;
                    margin-left: .4rem;
                    color: #FFDD00;
                }
            }

            @keyframes scroll {
                0% {
                    margin-top: 0;
                }

                100% {
                    margin-top: -2rem;
                }
            }
        }

        .right {
            padding: .7rem .8rem .5rem .25rem;
            background: url(~@/assets/tl/border2.png);
            // transform: rotateY(-180deg);

            .right-top {
                width: 100%;
                // height: 6.44rem;
                // background-color: pink;
                // margin-top: .45rem;
                // margin-left: .45rem;

                #lineChart1 {
                    margin-top: .25rem;
                    width: 100%;
                    height: 3.8rem;
                }
            }

            .right-bottom {
                // margin-top: .25rem;
                width: 100%;

                // height: 4.5rem;
                #barChart {
                    margin-top: .25rem;
                    width: 100%;
                    height: 3.7rem;
                }
            }
        }

        .footer {
            display: flex;
            justify-content: center;
            margin-top: -1.5rem;
        }

        .bottom {
            width: 15.98rem;
            height: 1.5rem;
            background: url(~@/assets/tl/twoMenu.png);
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: end;

            span {
                font-size: 0.21rem;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                padding: .15rem .4rem;
                cursor: pointer;
            }

            .active1 {
                position: relative;
                padding: .15rem .4rem;
                font-size: 0.21rem;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #32D0EB;
                cursor: pointer;

                &::after {
                    content: '';
                    background: url(~@/assets/tl/right.png)no-repeat center center;
                    background-size: 100% 100%;
                    width: .11rem;
                    height: .14rem;
                    position: absolute;
                    top: 0.18rem;
                    left: 0.12rem;
                    animation: rotateAgin2 1s ease-in-out infinite alternate;
                    // transform: rotateY(180deg);
                }

                &::before {
                    content: '';
                    background: url(~@/assets/tl/left.png)no-repeat center center;
                    background-size: 100% 100%;
                    width: .11rem;
                    height: .14rem;
                    position: absolute;
                    top: 0.18rem;
                    right: 0.12rem;
                    animation: rotateAgin 1s ease-in-out infinite alternate;
                }
            }
        }
    }

    @keyframes rotateAgin2 {
        0% {
            transform: translateX(5px);
            transition: all;
            opacity: 0.5;
        }

        100% {
            transform: translateX(-5px);
            transition: all;
            opacity: 1;
        }
    }

    @keyframes rotateAgin {
        0% {
            transform: translateX(-5px);
            transition: all;
            opacity: 0.5;

        }

        100% {
            transform: translateX(5px);
            transition: all;
            opacity: 1;
        }
    }

    .server {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        // background: linear-gradient(119deg, rgba(0, 222, 217, 0.2) 19%, rgba(0, 223, 218, 0) 88%);
        background: url(~@/assets/tl/hd-background2.png);
        background-size: 100% 100%;

        &::after {
            content: "";
            position: absolute;
            bottom: -0.1rem;
            right: 10px;
            width: calc(100vw * 125 / 1920);
            height: calc(100vw * 11 / 1920);
            background: url(https://rpt.gtc315.cn/site/tongliao/content/images/public/dot2.svg)no-repeat;
            background-size: 100% 100%;
            filter: drop-shadow(0 0 1px #0368cd);
            // z-index: -1;
        }

        .card_ {
            font-size: 0.2rem;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            padding-left: .56rem;
            text-shadow: 0px 0px 2px #34d6ff, 0px 0px 8px #34d6ff;
            font-style: italic;
        }

        .date {
            // margin-left: 1.2rem;
            color: #00E0DB;
            padding-right: 0.15rem;

            span {
                // padding: .05rem;
                display: inline-block;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                width: 0.44rem;
                height: 0.23rem;
                line-height: .2rem;
                background: linear-gradient(180deg, rgba(13, 142, 149, 0) 0%, rgba(13, 142, 149, 0.37) 87%);
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                opacity: 1;
                cursor: pointer;
                text-align: center;

            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        background: linear-gradient(180deg, rgba(13, 142, 149, 0) 0%, rgba(13, 142, 149, 0.55) 100%);
        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
        opacity: 1;
        border: 0.01rem solid #0D8E95;
        color: #00FFFF;
    }

    .add {
        display: flex;
        margin-top: .43rem;
        margin-left: .5rem;

        .add_item {
            display: flex;
            flex-direction: column;
            min-width: 3.5rem;
            // margin-right: 0.2rem;

            div {
                font-size: 0.15rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 0.18rem;
                padding-top: .1rem;

            }

            .num {
                display: block;
                font-size: 0.48rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: 700;
                color: #00FFFF;
                // line-height: 0.38rem;
                // padding-top: .11rem;
                // padding-left: .08rem;
            }

            div {
                // min-width: 3rem;
            }

        }
    }

    .block {
        margin-top: .48rem;
        margin-left: .25rem;
        display: flex;
        align-items: center;

        span:nth-child(1) {
            width: 0.11rem;
            height: 0.2rem;
            background: #00FFFF;
            opacity: 1;
        }


        span:nth-child(2) {
            margin-left: .15rem;
            font-size: 0.2rem;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #00FFFF;
            text-shadow: 0px 0px 2px #34d6ff, 0px 0px 8px #34d6ff;
            font-style: italic;
        }
    }

    .hand {
        font-size: 0.25rem;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
    }

    ul {
        // margin-top: .26rem;
        margin-left: .25rem;
        display: flex;

        li {
            width: 0.56rem;
            height: 0.63rem;
            background: rgba(0, 255, 255, 0.1);
            box-shadow: inset 0rem 0rem 0.13rem 0rem rgba(0, 255, 255, 0.4);
            border-radius: 0rem 0rem 0rem 0rem;
            opacity: 1;
            border: 0.01rem solid rgba(0, 255, 255, 0.2);
            font-size: 0.6rem;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: 700;
            color: #FFE11D;
            line-height: 0.6rem;
            text-align: center;
            margin-right: .14rem;
        }
    }

    .round {
        width: 0.15rem !important;
        height: 0.6rem !important;
        background: none !important;
        box-shadow: none !important;
        border: none !important;
        // margin: 0 .1rem !important;
        margin-top: .1rem;
    }



}
</style>
<style lang="scss">
.main {


    // DataV
    .dv-scroll-ranking-board .ranking-column {
        height: 0.15rem;
        background: #102c41;
        border: none;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-top: 5px;
    }

    .dv-scroll-ranking-board .ranking-column .inside-column {
        width: 5.5rem;
        height: 0.15rem;
        background: linear-gradient(270deg, #FFE11D 0%, #00E0DB 100%) !important;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-bottom: 0;
        overflow: hidden;
    }

    .dv-scroll-ranking-board .ranking-column .shine {
        background-color: transparent !important;
        animation: none !important;
    }

    .dv-scroll-ranking-board .ranking-info .rank {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .dv-scroll-ranking-board .ranking-info .info-name {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .ranking-value {
        font-size: 0.15rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFE11D;
    }

}
</style>